import { makeStyles } from 'lib/components';

export default makeStyles((theme) => ({
  inputTextfield: {
    height: '35px',
    cursor: 'pointer',
    backgroundColor: 'white',
    border: 'none',
    borderRadius: '4px',
    padding: '4px',
    width: '100px',
    fontSize: '16px',
    '&:hover': {
      borderColor: 'white',
    },
    '&:focus': {
      borderColor: 'white',
    },
    '& input[type="text"]': {
      marginLeft: '-6px',
      paddingLeft: '6px',
      '&:focus': {
        backgroundColor: theme.evPalette.huckleberry[200],
        borderRadius: '4px',
      },
      '&::placeholder': {
        fontSize: '14px',
      },
    },
    '&.myev-MuiInput-underline:before': {
      borderBottom: '0px solid white',
    },
    '&.myev-MuiInput-underline:after': {
      borderBottom: 'none',
    },
    '&.myev-MuiInput-underline:hover:before': {
      borderBottom: 'none',
    },
  },
  textPlaceHolder: {
    position: 'absolute',
    top: '50%',
    left: 14,
    transform: 'translateY(-50%)',
    color: '#82899C',
    pointerEvents: 'none',
    transition: 'all 0.2s ease',
  },
  selectedOption: {
    border: `1px solid ${theme.evPalette.ocean[600]}`,
    borderRadius: '4px',
    color: theme.evPalette.ocean[600],
  },
  optionValueTextField: {
    height: '35px',
    border: 'none',
    borderRadius: '4px',
    padding: '4px 8px',
    width: '263px',
    textAlign: 'left',
    alignContent: 'center',
    '@media(max-width: 1024px)': {
      width: '100%',
    },
  },
  datePickerContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    border: '1px solid #B4BAC7',
    borderRadius: '4px',
    backgroundColor: 'white',
    padding: '0px 8px',
    cursor: 'pointer',
    height: '44px',
  },
  datePickerPopperOpen: {
    border: '1px solid #007CAD',
    '&:hover': {
      backgroundColor: 'white',
    },
    '& .myev-MuiTouchRipple-root': {
      display: 'none',
    },
  },
  dateFilterContainer: {
    display: 'flex',
    width: '300px',
    flexDirection: 'column',
    position: 'relative',
    '@media(max-width: 1024px)': {
      width: '100%',
    },
  },
  dateOptionList: {
    width: '100%',
  },
  customDaysCountText: {
    display: 'flex',
    alignSelf: 'end',
    color: '#82899C',
    marginLeft: '4px',
  },
}));
